import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Backdrop } from "~/components/modal/backdrop";
export const PopupBackdrop = /*#__PURE__*/_styled(Backdrop, process.env.NODE_ENV === "production" ? {
  target: "e17jtchq0"
} : {
  target: "e17jtchq0",
  label: "PopupBackdrop"
})(process.env.NODE_ENV === "production" ? {
  name: "taq9ah",
  styles: "background:#000000;opacity:0.5"
} : {
  name: "taq9ah",
  styles: "background:#000000;opacity:0.5",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTZDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IHsgQmFja2Ryb3AgfSBmcm9tIFwifi9jb21wb25lbnRzL21vZGFsL2JhY2tkcm9wXCI7XG5cbmV4cG9ydCBjb25zdCBQb3B1cEJhY2tkcm9wID0gc3R5bGVkKEJhY2tkcm9wKWBcbiAgYmFja2dyb3VuZDogIzAwMDAwMDtcblxuICBvcGFjaXR5OiAwLjU7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});